import React from 'react';
import { AudioConfig } from './Hooks/useAudioConfig';

const AudioConfigContext = React.createContext<AudioConfig | null>(null);

export default AudioConfigContext;
